import { createSlice } from "@reduxjs/toolkit";
import { data } from "jquery";

const initialState = {
  data: [],
  individualData: [],
  group: [],
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setMember: (state, action) => {
      state.data = action.payload;
    },
    setIndividualData: (state, action) => {
      state.individualData = action.payload;
    },
    setMemberGroup: (state, action) => {
      state.group = action.payload;
    },
    clearMember: (state) => {
      state.data = [];
    },
    clearIndividual: (state) => {
      state.individualData = [];
    },
    clearMemberGroup: (state) => {
      state.group = [];
    },
  },
});
export const { setMember, clearMember, setIndividualData, clearIndividual, clearMemberGroup, setMemberGroup } = memberSlice.actions;

export default memberSlice.reducer;
